import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import parseColor from '../util/parseColor';
import { styled } from '../styled';
import { createMmmTheme } from '../Theme';

const Icon = createSvgIcon(
  <svg viewBox='0 0 21 16' fill='none' color='inherit' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.12684 11.1806C9.54399 11.5856 10.0696 11.776 10.7037 11.7517C11.3377 11.7274 11.7966 11.5046 12.0803 11.0833L17.6868 2.91667L9.27701 8.36111C8.84317 8.65278 8.6054 9.09433 8.56368 9.68576C8.52197 10.2772 8.70969 10.7755 9.12684 11.1806ZM3.7706 15.5556C3.40351 15.5556 3.06562 15.4786 2.75692 15.3247C2.44823 15.1707 2.20211 14.9398 2.01857 14.6319C1.58473 13.8704 1.25101 13.0804 1.0174 12.2622C0.783795 11.4439 0.666992 10.5972 0.666992 9.72222C0.666992 8.37731 0.929798 7.11343 1.45541 5.93056C1.98102 4.74768 2.69435 3.71875 3.5954 2.84375C4.49645 1.96875 5.55602 1.27604 6.7741 0.765625C7.99218 0.255208 9.2937 0 10.6786 0C12.0469 0 13.3317 0.251157 14.5331 0.753472C15.7345 1.25579 16.7858 1.94039 17.6868 2.80729C18.5878 3.67419 19.3054 4.68692 19.8393 5.84549C20.3733 7.00405 20.6486 8.24769 20.6653 9.57639C20.682 10.4676 20.5777 11.3385 20.3524 12.1892C20.1271 13.0399 19.7809 13.8542 19.3137 14.6319C19.1301 14.9398 18.884 15.1707 18.5753 15.3247C18.2666 15.4786 17.9287 15.5556 17.5617 15.5556H3.7706Z'
      fill='currentColor'
    />
  </svg>,
  'SpeedFilled',
);

const greenTheme = createMmmTheme({ mode: 'light', colors: 'default' });

const ColoredIcon = styled(Icon, {
  shouldForwardProp: (p) => p !== 'fillOpacity',
})(({
  theme,
  color = greenTheme.palette.primary.light,
  fillOpacity = 0.2,
}) => ({
  color: parseColor(theme, color),
  '& path': {
    fillOpacity,
  },
}));

export default ColoredIcon;
